export default __webpack_public_path__ + "static/media/0659.71411e5d.jpg";